import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import JoinResearch from "./Message";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function JoinResearchDialog({ open, handleClose }) {
  return (
    <Dialog
      fullScreen
      disableEscapeKeyDown
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <JoinResearch onClose={handleClose} />
    </Dialog>
  );
}
